import React from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import InputText from "shared/components/inputs/InputText";
import Button from "shared/components/buttons/Button";
import { useDispatch, useSelector } from "react-redux";
import { updateConfigAI } from "redux/actions/configAI/configAiUpdate";
import { snackbarSuccess } from "shared/redux/actions/Snackbar";
import RAGFiles from "containers/manage/BookEdit/sections/Rag/RAGFiles";
import { useParams } from "react-router";
import { useState } from "react";

const Info = ({ onCancel, chapterId, bookId }) => {
    const { control, handleSubmit } = useForm();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { osbn } = useParams();
    const config = useSelector((state) => state.configAI.config);
    const aiMap = config.aiMap || [];
    const { current: organisation } = useSelector(state => state.organisation);
    const [uploadedFiles, setUploadedFiles] = useState([]);


    const stripTypename = (obj) => {
        if (Array.isArray(obj)) {
            return obj.map(stripTypename);
        } else if (obj && typeof obj === "object") {
            const cleaned = {};
            for (const key in obj) {
                if (key === "__typename") continue;
                cleaned[key] = stripTypename(obj[key]);
            }
            return cleaned;
        }
        return obj;
    };
    const chapterConfig = aiMap.find((item) => item.chapterId === chapterId) || {};

    const onSubmit = (form) => {
        let updatedAiMap = aiMap.map((item) =>
            item.chapterId === chapterId ? { ...item, ...form, uploadedFiles, isEnabled: true } : item
        );

        if (!updatedAiMap.find((item) => item.chapterId === chapterId)) {
            updatedAiMap.push({ chapterId, ...form, isEnabled: true });
        }


        updatedAiMap = stripTypename(updatedAiMap);

        const configData = {
            id: config.id,
            organisationId: config.organisationId,
            bookId: config.bookId,
            apikey: config.apikey,
            prompt: config.prompt,
            provider: config.provider,
            model: config.model,
            osbn,
            aiMap: updatedAiMap,
            vectorStoreId: config.vectorStoreId
        };

        onCancel();
        dispatch(updateConfigAI(configData));
        dispatch(snackbarSuccess("AI configuration changes have been saved."));
    };

    return (
        <div className="flow-item-form-content">
            <p>{t("book.chapter.ai.summary")}</p>
            <div className="spacer" />

            <h5 className="subtitle">{t("book.chapters.ai.laws")}</h5>
            <InputText
                label={t("book.chapters.ai.laws")}
                name="laws"
                multiline
                control={control}
                rules={{ required: false }}
                defaultValue={chapterConfig.laws || ""}
            />
            <h5 className="subtitle">{t("book.chapters.ai.industry")}</h5>
            <InputText
                label={t("book.chapters.ai.industry")}
                name="industry"
                multiline
                control={control}
                rules={{ required: false }}
                defaultValue={chapterConfig.industry || ""}
            />

            <h5 className="subtitle">{t("book.chapters.ai.branch")}</h5>
            <InputText
                label={t("book.chapters.ai.branch")}
                name="branch"
                multiline
                control={control}
                rules={{ required: false }}
                defaultValue={chapterConfig.branch || ""}
            />

            <div className="spacer-double" />
            <RAGFiles
                bookId={bookId}
                chapterId={chapterId}
                organisationId={organisation.id}
                onFilesChange={setUploadedFiles} />
            <div className="container-buttons">
                <Button
                    outlined
                    spacedRight
                    label={t("button.cancel.label")}
                    onClick={onCancel}
                />
                <Button
                    label={t("button.save.label")}
                    onClick={handleSubmit(onSubmit)}
                />
            </div>
        </div>
    );
};

Info.propTypes = {
    onCancel: PropTypes.func.isRequired,
    chapterId: PropTypes.string.isRequired
};

export default Info;
